export const FILENAME_MATCH_MODES = {
    file_id: 'exact_base',
    exact: 'exact',
    partial: 'contains',
};

const GENERAL_TEXT_MATCHING_MODES = new Set(['contains', 'exact', 'starts', 'ends']);

export const normalizeGeneralTextSearchMatching = (matchingMode) => (
    GENERAL_TEXT_MATCHING_MODES.has(matchingMode) ? matchingMode : 'contains'
);

const removeMatchingQuotes = (value) => {
    const trimmed = value.trim();
    const quote = trimmed[0];

    if ((quote === '"' || quote === "'") && trimmed.at(-1) === quote) {
        return trimmed.slice(1, -1).trim();
    }

    return trimmed;
};

export const parseFilenameSearchTerms = (text, matchMode) => {
    const searchText = String(text || '').trim();
    if (!searchText) return [];

    const lines = searchText.split(/\r?\n/).map(value => value.trim()).filter(Boolean);
    let entries;

    if (lines.length > 1) {
        entries = lines;
    } else {
        const commaParts = searchText.split(',').map(value => value.trim()).filter(Boolean);
        const commaSeparated = commaParts.length > 1 && (
            matchMode === 'file_id' || commaParts.every(value => value.includes('.'))
        );

        entries = commaSeparated ? commaParts : searchText.split(' ');
    }

    return entries.map(removeMatchingQuotes).filter(Boolean);
};
